export type DossierLightUpdateResult =
  | DossierLightUpdateSuccess
  | DossierLightUpdateError;

export interface DossierLightUpdateSuccess {
  canUpdate: true;
}

export interface DossierLightUpdateError {
  canUpdate: false;
  errors: DossierLightUpdateErrorInstance[];
}

export interface DossierLightUpdateErrorInstance {
  errorType: DossierLightUpdateErrorType;
  displayInterpolationParams?: any;
}

export const DossierLightUpdateErrorType = {
  CurrentlyInUse: 'CurrentlyInUse',
  AmbiguousTechAssign: 'AmbiguousTechAssign',
  ApmtAlreadyExists: 'ApmtAlreadyExists',
  MissingAddrForMobility: 'MissingAddrForMobility',
  RVUseMismatchApmtTimes: 'RVUseMismatchApmtTimes',
  ReplacementVehicleUnavailable: 'ReplacementVehicleUnavailable',
  InterventionVehicleUnavailable: 'InterventionVehicleUnavailable',
  TechnicianUnavailable: 'TechnicianUnavailable',
} as const;
export type DossierLightUpdateErrorType =
  typeof DossierLightUpdateErrorType[keyof typeof DossierLightUpdateErrorType];
